module.exports = __webpack_public_path__ + "static/media/masterDev-logo.e284071d.svg";